export const Status = {
    LOADING: 'loading',
    ERROR: 'error',
    WRONG_TOKEN: 'wrongToken',
    COMPLETE: 'complete'
};